import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
  useCallback,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import { ColumnConfig } from "@shared/components/Grid/types";
import SnTree from "@shared/components/GridV2/SnTree";
import SnResizeBar from "@shared/components/SnResizeBar";
import { ColDef } from "ag-grid-community";
import SnButton from "@shared/components/SnButton";
import SnGrid from "@shared/components/GridV2/SnGrid"; // 공통 그리드
import { dateToString, formatYyyyMMdd } from "@shared/utils/DateUtils";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";
interface Props {
  Menuprops: menuInfo;
}

const SN_PRD_BAS_REP_002 = forwardRef(({ Menuprops }: Props, ref) => {
  const searchRef = useRef<any>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    tree: React.createRef(),
  });
  const [columns, setColums] = useState<any>({
    tree: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    tree: [],
  });
  /*
   const today = new Date();
   const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
     .toString()
     .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
      const popDate = new Date();
      popDate.setDate(1);
      const firstDayOfMonth = `${popDate.getFullYear()}${(
        popDate.getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}${popDate.getDate().toString().padStart(2, "0")}`;
*/
  const { userInfo } = global();

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums({
          tree: rtn.grid.grid1,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  const onSearch = async () => {
    try {
      if (searchRef.current.getFormdata().cd_item == "") {
        await showDialog("alter", "품목을 선택해 주세요.");
        return;
      }
      const param = {
        id: "sn_prd_bas_rep_002_01",
        params: searchRef.current.getFormdata(),
      };

      gridRefs.current["tree"].current.resetUpdate();
      const data: any = await fnGetDataSet(param);
      setDataSources({
        tree: data[0] || [],
      });
    } catch (error) {}
  };
  const onGridBtnsClick = async (id: string) => {
    const api = gridRefs.current["tree"].current;
    if (!api) return;
    if (id === "btnOpen") {
      api.setExpandedAll(true);
    }
    if (id === "btnClose") {
      api.setExpandedAll(false);
    }
  };
  useImperativeHandle(ref, () => ({
    onSearch,
  }));
  const autoGroupColumnDef = useMemo<ColDef>(() => {
    return {
      headerName: "자품목코드",
      field: "cd_child",
      minWidth: 300,
      cellRendererParams: {
        suppressCount: true, // 하위 아이템 개수 숨기기
        suppressDoubleClickExpand: true, // 더블 클릭으로 확장/축소 비활성화
        suppressHoverHighlight: false,
      },
      rowDrag: false,
    };
  }, []);

  const getRowId = useCallback(
    (params: any) => String(params.data.cd_level),
    []
  );

  const grids = useMemo(
    () => ({
      tree: {
        columns: columns.tree,
        dataSource: dataSources.tree,
      },
    }),
    [columns, dataSources]
  );
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex-1">
        <SnResizeBar direction={"height"} id="panel1" orgSize="49.5%">
          <SnTree
            ref={gridRefs.current["tree"]} // Grid Name
            columnConfig={grids.tree.columns} // 컬럼 설정 전달
            rowData={grids.tree.dataSource} // Datasource
            etcProps={{ rowSelection: "single", title: "BOM정보" }}
            header={
              <div>
                <SnButton
                  text={"전체전개"}
                  onClick={() => {
                    onGridBtnsClick("btnOpen");
                  }}
                />
                <SnButton
                  text={"전체닫기"}
                  onClick={() => {
                    onGridBtnsClick("btnClose");
                  }}
                />
              </div>
            }
            treeProps={{
              treeDataParentIdField: "cd_plevel",
              treeIdKey: "cd_level",
              treeOrderKey: "no_level",
              groupDefaultExpanded: -1,
              autoGroupColumnDef: autoGroupColumnDef,
              getRowId: getRowId,
            }}
          />
        </SnResizeBar>
      </div>
    </div>
  );
});

export default SN_PRD_BAS_REP_002;
